module.exports = __webpack_public_path__ + "img/img-d2ee0b.png";